const NotFoundPage = ({ t }) => (
  <main className="notfound" data-testid="notfound-page">
    <h1>{t.notfound.title}</h1>
    <p>{t.notfound.text}</p>
    <a className="btn-gold" href="/" data-testid="notfound-home-link">
      {t.notfound.cta} <span className="arr">↗</span>
    </a>
  </main>
);

export default NotFoundPage;
